export default {"faq":"RaO4r","header":"e98Vt","title":"-Kmew","body":"ArR1K","openBody":"_6d1r-"};